import {
  EClaimType,
  ERefundMethods,
  ERefundOption,
  TLetterFlowOption,
  TLetterFlowSteps,
  TRefundOption,
} from './types';

export const envs = {
  API_URL: import.meta.env.VITE_API_URL,
  RECAPTCHA_KEY: import.meta.env.VITE_RECAPTCHA_KEY,
  DISABLE_RECAPTCHA: import.meta.env.VITE_DISABLE_RECAPTCHA === 'true',
  ASSETS_URL: import.meta.env.VITE_ASSETS_URL,
  ENVIRONMENT: import.meta.env.VITE_ENV_MODE,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
};
export const TangoMaxAmount = 1000;

export const refundOptionsArray: TRefundOption[] = [
  {
    heading: 'Recommended',
    title: ERefundOption.DIRECT_DEPOSIT,
    time: '3-5 business days',
    description:
      'Fast and secure using our state of the art encrypted payment processing.',
    action: 'Choose Direct Deposit',
    isRecommended: true,
    path: '/payments/payment-methods/direct-deposit',
    allowFor: [EClaimType.EMAIL, EClaimType.LETTER],
    refundMethod: ERefundMethods.ACH,
  },
  {
    heading: 'Quickest',
    title: ERefundOption.DIGITAL_PAYMENTS,
    time: 'Instant',
    description: 'Fast and secure using Venmo or Paypal payment services.',
    action: 'Choose Venmo/Paypal',
    isRecommended: false,
    path: '/payments/payment-methods/digital-payments',
    allowFor: [EClaimType.EMAIL],
    refundMethod: ERefundMethods.VENMO,
    limit: TangoMaxAmount,
  },
  {
    heading: 'Quickest',
    title: ERefundOption.GIFT_CARD,
    time: 'Instant',
    description:
      'Choose between a Visa gift card or some of your favorite brands.',
    action: 'Get Gift Card',
    isRecommended: false,
    path: '/payments/payment-methods/gift-cards',
    allowFor: [EClaimType.EMAIL],
    refundMethod: ERefundMethods.GIFTCARD,
    limit: TangoMaxAmount,
  },
  {
    heading: 'Quickest',
    title: ERefundOption.DONATE_REFUND,
    time: 'Instant',
    description: 'Use your funds to make the world a better place.',
    action: 'Donate to Charity',
    isRecommended: false,
    path: '/payments/payment-methods/donation',
    allowFor: [EClaimType.EMAIL],
    refundMethod: ERefundMethods.DONATION,
    limit: TangoMaxAmount,
  },
  {
    heading: 'Slowest',
    title: ERefundOption.CHECK_MAIL,
    time: '10-15 Business Days',
    description:
      'Please allow extra time for these payments due to the manual nature of check payments.',
    action: 'Get a Physical Check',
    isRecommended: false,
    path: '/payments/payment-methods/check',
    allowFor: [EClaimType.EMAIL, EClaimType.LETTER],
    refundMethod: ERefundMethods.CHECK,
  },
];
export const letterFlowSteps: TLetterFlowSteps[] = [
  {
    title: 'Code Confirmation',
    description: 'Use the received code to confirm.',
    isActive: false,
    path: '/letter-flow',
  },
  {
    title: 'Select Your Preferred Payment Type',
    description: 'You can chose between four options, depending on your need.',
    isActive: false,
    path: '/letter-flow/choose-method',
  },
  {
    title: 'Claim Payment',
    description: 'Claim your reward and check your mail for confirmation.',
    isActive: false,
  },
];

export const letterFlowOptions: TLetterFlowOption[] = [
  {
    tag: 'digital',
    title: 'Payment by digital payment',
    description:
      'This option will allow you to recieve your payment in 3-5 business days.',
    method: 'direct-deposit',
  },
  /*
  {
    tag: 'digital',
    title: 'Donate refund to charity',
    description: 'Instant delivery.',
  },
    */
  {
    tag: 'paper check',
    title: 'Payment by mail',
    description:
      'This payment can take up to 20 business days and is delivered by the US Postal Service.',
    method: 'refund-email',
  },
];
